type callBack = (intersectionObserverEntry: IntersectionObserverEntry) => void;
export default function WilIntersectionObserver(fn: callBack[], option?: IntersectionObserverInit) {
  // 如果IntersectionObserver不存在时需要静默失败, 而通常需要两种情况, 打包成两种版本, 一种可以抛出错误, 一种静默失败
  if (!(window as any).IntersectionObserver) {
    return undefined;
  }

  const defaultOption: IntersectionObserverInit = {
    root: null,
    rootMargin: "0px",
    threshold: [0]
  };
  let callBacks: Array<callBack> = fn
  const observerHandle = function(
    intersectionObserverEntrys: IntersectionObserverEntry[]
  ) {
    intersectionObserverEntrys.forEach(intersectionObserverEntry => {
      callBacks.forEach(fn => {
        fn(intersectionObserverEntry);
      });
    });
  };

  const observer = new IntersectionObserver(
    observerHandle,
    Object.assign({}, defaultOption, option)
  );
  return observer;
}
export * from './helper';